  import forge from 'node-forge';

  // Cache keys for the current cycle
  let cachedKeys = null;

  export const dynamicKeys = () => {
  // Return cached keys if already generated
  if (cachedKeys) {
    return cachedKeys;
  }

  const keypair = forge.pki.rsa.generateKeyPair({ bits: 2048, e: 0x10001 });
  const publicKey = forge.pki.publicKeyToPem(keypair.publicKey);
  const privateKey = forge.pki.privateKeyToPem(keypair.privateKey);  

  cachedKeys = { publicKey, privateKey };
  return cachedKeys;

};

// Call this to generate new keys for a new cycle
export const resetKeys = () => {
  cachedKeys = null;
};